// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>21</span>&nbsp;&nbsp;The Lord watches over those who love him,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;but all the wicked shall he destroy.<br> </p> </div></div>";
// Exports
module.exports = code;